<template>
    <div>
        <div v-if="label" class="label flex justify-between">
            <p>
                {{ label }}
                <TranslateText :text="trans"/>
            </p>

            <slot name="label-right"/>
        </div>
        <input
            class="rounded-lg w-full bg-slate-100 focus:ring-slate-600 focus:border-slate-600 py-[6px]"
            :class="[
                errors && errors.length && 'border-red-300 text-red-900 placeholder-red-300',
                (!errors || !errors.length) && 'border border-slate-100',
                small && 'text-sm px-2 py-1',
            ]"
            :type="type"
            :value="modelValue"
            :placeholder="placeholder"
            v-bind="$attrs"
            @input="$emit('update:modelValue', $event.target.value)"
            @blur="$emit('blur', $event.target.value)"
        />
        <p v-if="errors && errors.length" class="mt-1 text-sm text-red-600">
            <span v-for="error in errors" :key="error" v-text="error" class="block"/>
        </p>
    </div>
</template>

<script setup>
import TranslateText from "@/components/TranslateText.vue";
import debounce from "lodash.debounce";
import { watch } from "vue";
const emit = defineEmits(['update:modelValue', 'changed-debounce']);

const props = defineProps({
    modelValue: [String, Number],
    label: String,
    trans: String,
    placeholder: String,
    small: Boolean,
    type: {
        type: String,
        default: 'text'
    },
    errors: {
        required: false,
        type: Array
    },
});

watch(() => props.modelValue, debounce(() => {
    emit('changed-debounce')
}, 500));
</script>
